export default __webpack_public_path__ + "static/media/bandcamp.ec33d7d4.svg";